"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = exports.TYPES = exports.VARIANTS = exports.SIZES = void 0;
const util_1 = require("@app/util");
const _ui_1 = require("@ui");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
require("./style.scss");
var SIZES;
(function (SIZES) {
    SIZES["SMALL"] = "SMALL";
    SIZES["MEDIUM"] = "MEDIUM";
    SIZES["LARGE"] = "LARGE";
    SIZES["FULL_WIDTH"] = "FULL_WIDTH";
})(SIZES || (exports.SIZES = SIZES = {}));
var VARIANTS;
(function (VARIANTS) {
    VARIANTS["NORMAL"] = "NORMAL";
    VARIANTS["SLIM"] = "SLIM";
})(VARIANTS || (exports.VARIANTS = VARIANTS = {}));
var TYPES;
(function (TYPES) {
    TYPES["INFO"] = "INFO";
    TYPES["WARNING"] = "WARNING";
    TYPES["ERROR"] = "ERROR";
    TYPES["SUCCESS"] = "SUCCESS";
})(TYPES || (exports.TYPES = TYPES = {}));
const Alert = ({ customIco, size = SIZES.MEDIUM, variant = VARIANTS.NORMAL, type = TYPES.INFO, text, children, buttonText, onClick, style, }) => {
    const decideIco = () => {
        switch (type) {
            case TYPES.ERROR:
                return _ui_1.Icon.ICONS.warning;
            case TYPES.SUCCESS:
                return _ui_1.Icon.ICONS.success;
            case TYPES.WARNING:
                return _ui_1.Icon.ICONS.warning;
            default:
                return _ui_1.Icon.ICONS.info;
        }
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('alert', size?.toLowerCase(), variant?.toLowerCase(), type?.toLowerCase()), style: style },
        react_1.default.createElement(_ui_1.Icon, { ico: customIco || decideIco(), size: _ui_1.Icon.SIZES.SMALL }),
        (0, util_1.isValue)(text) ? react_1.default.createElement("div", { className: 'text' }, text) : children,
        ((0, util_1.isDefined)(buttonText) || (0, util_1.isDefined)(onClick)) && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { style: { flex: 1 } }),
            react_1.default.createElement("div", { style: {
                    flexShrink: 0,
                    cursor: 'pointer',
                    textDecorationLine: 'underline',
                    marginLeft: '1rem',
                }, onClick: onClick, className: 'button' }, buttonText)))));
};
exports.Alert = Alert;
Alert.SIZES = SIZES;
Alert.VARIANTS = VARIANTS;
Alert.TYPES = TYPES;
